const $ = jQuery.noConflict();
import 'slick-carousel';

'use strict';

/** @description Helper Classes for creating base config options. */
class SliderBaseConfig {
	constructor(slidesToShow = 4, slidesToScroll = 1, speed = 1000, rows = 0) {
		this.slidesToShow = slidesToShow;
		this.slidesToScroll = slidesToScroll;
		this.speed = speed;
		this.rows = rows;
	}
}

const Sliders = {
	/** @description Cache dom and strings. */
	$domBrandsSlider: $('.js-brands-slider'),
	$domTestimonialsSlider: $('.js-testimonials-slider'),

	/** @description Initialize. */
	init: function() {
		this.brandsSlider();
		this.testimonialsSlider();
	},

	/** @description Set and run gallery slider. */
	brandsSlider: function() {
		// create object with base config options
		const baseConfig = new SliderBaseConfig();
		// set extra config options
		const extraConfig = {
			slidesToShow: 6,
			autoplay: true,
			autoplaySpeed: 0,
			speed: 4000,
			cssEase: 'linear',
			infinite: true,
			focusOnSelect: false,
			pauseOnHover: false,
			arrows: false,
			responsive: [
				{
					breakpoint: 1200,
					settings: {
						slidesToShow: 4
					}
				},
				{
					breakpoint: 991,
					settings: {
						slidesToShow: 3
					}
				},
				{
					breakpoint: 576,
					settings: {
						slidesToShow: 2
					}
				},
				{
					breakpoint: 400,
					settings: {
						slidesToShow: 1.5
					}
				}
			]
		};
		// merge two config objects
		const config = {
			...baseConfig,
			...extraConfig
		};
		// run slider
		this.runSlider(this.$domBrandsSlider, config);
	},

	testimonialsSlider: function() {
		// create object with base config options
		const baseConfig = new SliderBaseConfig();
		// set extra config options
		const extraConfig = {
			slidesToShow: 4,
			autoplay: true,
			speed: 1000,
			infinite: true,
			arrows: true,
			prevArrow: $('.js-testimonials-prev'),
			nextArrow: $('.js-testimonials-next'),
			responsive: [
				{
					breakpoint: 1200,
					settings: {
						slidesToShow: 2.65
					}
				},
				{
					breakpoint: 991,
					settings: {
						slidesToShow: 2
					}
				},
				{
					breakpoint: 640,
					settings: {
						slidesToShow: 1
					}
				},
			]
		};

		this.$domTestimonialsSlider.each(function(e, el) {
			$(el).on('beforeChange', function() {
				$('.js-slider-read-more').each(function() {
					const parentElement = $(this).parents('.js-testimonial-slider-parent');
					const innerText = $('.js-inner-text');
					const fullText = parentElement.find('.js-text-content').attr('data-ShortText');

					parentElement.find('.js-text-content p .js-more-inner').text(fullText);
					parentElement.find('.js-slider-read-more').text('Read More').removeClass('read-less');
					innerText.removeClass('hide');
				});
			});
		});

		// merge two config objects
		const config = {
			...baseConfig,
			...extraConfig
		};
		// run slider
		this.runSlider(this.$domTestimonialsSlider, config);
	},

	/** @description Loop through sliders and run. */
	runSlider: ($slider, config) => {
		$slider.each((i, el) => {
			$(el).slick(config);
		});
	}
};

export default Sliders;
